import React from 'react'
import BaseMaterial from '../materials/BaseMaterial.jsx'
import { PlaneGeometry } from 'three'

export default function BasePlane( props) 
{

  const geometry = new PlaneGeometry( 3.2, 3.2, 1, 1 )
  geometry.computeTangents()

  return (
    <mesh
      geometry={ geometry }
      {...props }
    >
        <BaseMaterial
          transparent={ true}
        />
    </mesh>
  )
}
